module.exports = __webpack_public_path__ + "img/56878730129766812.f5e540b7.png";